// extracted by mini-css-extract-plugin
module.exports = {"floatAd":"floatAd-37oYXiAT"};